<ng-container>
  <div class="field-container">
    <label class="form-label">{{labelText}}<span class="text-danger" *ngIf="required">*</span></label>
    <div class="autocomplete-wrapper" [ngClass]="showExtraButton ? 'has-extra-button' : ''">
      <p-autocomplete [(ngModel)]="selectedValue" [panelStyle]="{ width: overlayWidth }" size="small"
        placeholder="Seleccione" [dropdown]="!disabledList" [readonly]="disabledList" [showClear]="disabledList"
        [suggestions]="filteredList" class="w-full {{class}}" appendTo="body"
        [emptyMessage]="'No hay coincidencias'" autocomplete="off" [ngClass]="recovery ? 'recover-data' : ''"
        (ngModelChange)="onChange($event)" optionLabel="label" optionDisabled="disabled" (completeMethod)="filterItems($event)"
        (onSelect)="changeSelected($event)" [disabled]="disabled" (onClear)="changeSelected($event)"
        (onBlur)="manualChange($event)" (onFocus)="selectAllText($event)" [autoOptionFocus]="true"
        [virtualScroll]="true" [virtualScrollOptions]="{ itemSize: 38, appendOnly: true }" [scrollHeight]="'250px'"
        (onShow)="calculateOverlayWidth()" />
      <p-button *ngIf="showExtraButton" class="extra-button" [pTooltip]="titleExtraButton" [icon]="iconExtraButton"
        [disabled]="disabled" [ngClass]="recovery ? 'recover-data-extra-button' : ''" severity="secondary"
        (onClick)="emitExtraButtonClick()">
      </p-button>
    </div>
  </div>
</ng-container>